import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ServicePortalApi } from '../../../api/api';
import { RoleInput } from '../../../api/types';
import { RoleFormComponent } from './role-form.component';
import { SynBreadcrumbComponent, SynBreadcrumbItemComponent } from '@synergy-design-system/angular';
import { globalClientId } from '../../state';

@Component({
  selector: 'app-add-role',
  template: `
    <syn-breadcrumb>
      <syn-breadcrumb-item routerLink="" i18n="@@home">Home</syn-breadcrumb-item>
      <syn-breadcrumb-item routerLink="/clients" i18n="@@clients">Clients</syn-breadcrumb-item>
      <syn-breadcrumb-item [routerLink]="['/', 'clients', clientId]">{{ globalClientId() ?? clientId }}
      </syn-breadcrumb-item>
      <syn-breadcrumb-item [routerLink]="['/', 'clients', clientId, 'roles']" i18n="@@roles">Roles</syn-breadcrumb-item>
      <syn-breadcrumb-item i18n="@@add-role">Add Role</syn-breadcrumb-item>
    </syn-breadcrumb>

    <h1 i18n="@@add-role">Add Role</h1>

    <app-role-form
      [role]="emptyRole"
      submitIcon="save"
      submitText="Add Role"
      i18n-submitText="@@add-role"
      [canEdit]="canEdit"
      (submitRole)="onSubmit($event)"
    />
  `,
  styles: [],
  imports: [
    RoleFormComponent,
    RouterLink,
    SynBreadcrumbComponent,
    SynBreadcrumbItemComponent,
  ],
})
export class AddRoleComponent {
  clientId = inject(ActivatedRoute).snapshot.params['id'];
  api = inject(ServicePortalApi);
  router = inject(Router);

  canEdit = true;

  emptyRole: RoleInput = {
    name: '',
    description: '',
    isPublic: false,
  };

  onSubmit(role: RoleInput) {
    this.api.createClientRole(this.clientId, role, (updatedRole) => {
      void this.router.navigate(['clients', this.clientId, 'roles', updatedRole.id])
        .then(() => {
        });
    });
  }

  protected readonly globalClientId = globalClientId;
}
